import axios from "axios";

export const createPDSA = async (username, pdsaVOtoCreate) => {
    try {
        const {data} = await axios.post("/api/pdsa/create", {username, pdsaVOtoCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewPDSA = async (username, pdsaExternalReference) => {
    try {
        const {data} = await axios.post("/api/pdsa/view", {username, pdsaExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const viewPDSAsForChangeIdea = async (username, changeIdeaExternalReference) => {
    try {
        const {data} = await axios.post("/api/pdsa/viewPDSAsForChangeIdea", {username, changeIdeaExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}


export const deletePDSA = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/pdsa/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updatePDSA = async (username, pdsaVOToUpdate, version) => {
    try {
        const {data} = await axios.post("/api/pdsa/update", {username, pdsaVOToUpdate, version});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
